import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-arrow-external-link",
  "use": "various-arrow-external-link-usage",
  "viewBox": "0 0 24 19",
  "content": "<symbol viewBox=\"0 0 24 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-arrow-external-link\"><path d=\"M9.984 8.012V14l14-7-14-7v6.012H0v13h2v-11h7.984z\" fill=\"#e3000f\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol